module.exports = __webpack_public_path__ + "icon_3.8d0fc7c7.png";